import { useEffect, useState } from 'react';
import ModalWrapper from './modal-wrapper';
import Step01 from './steps/step-01';
import Step02 from './steps/step-02';
import Step03A from './steps/step-03-a';
import Step03B from './steps/step-03-b';
import Step03C from './steps/step-03-c';
import Step04 from './steps/step-04';
import Step05A from './steps/step-05-a';
import Step05C from './steps/step-05-c';
import Step05D from './steps/step-05-d';
import Step06 from './steps/step-06';
import { useFinishOnboarding } from '../../hooks/use-onboarding';
import { Button } from '../../../../core/components/atoms/Button';

export const Onboarding = () => {
  const { finishOnboarding, isFinishedOnboarding, isLoadingFinishOnboarding } =
    useFinishOnboarding();
  const [activeStep, setActiveStep] = useState('1');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNextStep = () => {
    const nextStep = steps.findIndex((step) => step.key === activeStep) + 1;
    setActiveStep(steps[nextStep].key);
  };

  const handlePreviousStep = () => {
    const previousStep = steps.findIndex((step) => step.key === activeStep) - 1;
    setActiveStep(steps[previousStep].key);
  };

  const handleFinishOnboarding = () => {
    try {
      finishOnboarding();
      setActiveStep('1');
      setIsModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  const steps = [
    { key: '1', children: <Step01 onNextStep={handleNextStep} /> },
    {
      key: '2',
      children: (
        <Step02
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
        />
      ),
    },
    {
      key: '3A',
      children: (
        <Step03A
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
        />
      ),
    },
    {
      key: '3B',
      children: (
        <Step03B
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
        />
      ),
    },
    {
      key: '3C',
      children: (
        <Step03C
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
        />
      ),
    },
    {
      key: '4',
      children: (
        <Step04
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
        />
      ),
    },
    {
      key: '5A',
      children: (
        <Step05A
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
        />
      ),
    },
    {
      key: '5C',
      children: (
        <Step05C
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
        />
      ),
    },
    {
      key: '5D',
      children: (
        <Step05D
          onNextStep={handleNextStep}
          onPreviousStep={handlePreviousStep}
        />
      ),
    },
    {
      key: '6',
      children: (
        <Step06
          onNextStep={handleFinishOnboarding}
          onPreviousStep={() => setActiveStep('1')}
        />
      ),
    },
  ];

  const Component = steps.find((step) => step.key === activeStep)?.children;

  useEffect(() => {
    if (isFinishedOnboarding || isLoadingFinishOnboarding) return;

    setIsModalOpen(true);
  }, [isFinishedOnboarding]);

  return (
    <div>
      <div className='flex justify-center md:justify-end'>
        <Button
          allowReadOnly
          variant='text'
          LeftIcon={'info'}
          onClick={() => setIsModalOpen(true)}
        >
          Como os<i>flashcards</i>funcionam?
        </Button>
      </div>

      <div className='mt-4 flex flex-col gap-10'>
        <ModalWrapper open={isModalOpen} onClose={() => setIsModalOpen(false)}>
          {Component}
        </ModalWrapper>
      </div>
    </div>
  );
};
